export default "/img/CR.0cefbd21f01b2f4657db592b3e0e30eb.png";